<template>
  <el-image :style="{width:width+'px',height:height+'px'}" :preview-src-list="imgList" v-if="imgList&&imgList.length>0"
            :src="imgList[0]" fit="cover">
  </el-image>
</template>

<script>
export default {
  name: 'ImgViewer',
  props: {
    imgs: {
      type: Array | String,
      default: ''
    },
    width: 100,
    height: 100,
  },
  watch: {
    imgs: {
      handler: function (newVal) {
        if (newVal === null || newVal === undefined) {
          this.imgList = []
          return
        }
        if (typeof newVal == 'string'&&newVal!=='') {
          //先做json转换
          try{
            this.imgList=JSON.parse(newVal)
          }catch (e) {
            //不是json
            this.imgList = newVal.split(',')
          }
          return
        }
        if (newVal instanceof Array) {
          this.imgList = newVal
          return
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      imgList: []
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
